var _excluded = ["placeholder", "sx"],
  _excluded2 = ["errorMessage", "placeholder", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { forwardRef, useTheme, useStyles } from '../../../system';
import { FormControl, FormErrorMessage } from '../../../components/form-control';
import { useSearch } from './useSearch';
import { Input, InputGroup, InputRightAddon } from '../../../components/input';
import { tqc } from '../../../system';
import { createContext } from '../../../utils';
import { FaSearch } from 'react-icons/fa';
import { IconButton } from '../../../components';
import { split } from '../../../utils';
var [SearchInputProvider, useSearchInputContext] = createContext({
  name: 'SearchInputContext',
  errorMessage: 'useSearchInputContext: `context` is undefined. Seems you forgot to wrap component within a SearchInputProvider'
});
export { useSearchInputContext };
var SearchIcon = tqc(FaSearch);
export var SearchInputField = forwardRef((props, ref) => {
  var {
      placeholder,
      sx
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var {
    getInputProps
  } = useSearchInputContext();
  return /*#__PURE__*/React.createElement(Input, _extends({
    placeholder: placeholder || 'Enter search term'
  }, getInputProps === null || getInputProps === void 0 ? void 0 : getInputProps(rest), {
    sx: _objectSpread({
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }, sx),
    ref: ref
  }));
});
SearchInputField.displayName = 'SearchInputField';
export var SearchInputButton = forwardRef((props, ref) => {
  var styles = useStyles();
  var {
    getActionProps
  } = useSearchInputContext();
  return /*#__PURE__*/React.createElement(InputRightAddon, _extends({
    ref: ref,
    as: IconButton,
    children: /*#__PURE__*/React.createElement(SearchIcon, null),
    __css: _objectSpread({}, styles.addon)
  }, getActionProps === null || getActionProps === void 0 ? void 0 : getActionProps(props)));
});
SearchInputButton.displayName = 'SearchInputButton';
export var SearchInputIconAddOn = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(InputRightAddon, _extends({
    ref: ref,
    as: "span",
    children: /*#__PURE__*/React.createElement(SearchIcon, null),
    __css: _objectSpread({}, styles.addon),
    _hover: {},
    _active: {},
    _focus: {}
  }, props));
});
SearchInputIconAddOn.displayName = 'SearchInputIconAddOn';
export var SearchInput = forwardRef((props, ref) => {
  var _theme$components;
  var {
      errorMessage,
      placeholder,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var theme = useTheme();
  var searchInputStyleConfig = (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.SearchInput;
  var [searchProps, controlProps] = split(rest, ['searchOnCharacterCount', 'value', 'searchOnEnter', 'defaultValue', 'debounceMillis', 'onChange', 'onSearch']);
  var useSearchProps = useSearch(_objectSpread({}, searchProps));
  return /*#__PURE__*/React.createElement(SearchInputProvider, {
    value: useSearchProps
  }, /*#__PURE__*/React.createElement(FormControl, _extends({
    ref: ref,
    role: "search"
  }, controlProps), /*#__PURE__*/React.createElement(InputGroup, {
    className: "tqc-input__search-group",
    styleConfig: searchInputStyleConfig
  }, children), errorMessage && /*#__PURE__*/React.createElement(FormErrorMessage, null, errorMessage)));
});
SearchInput.displayName = 'SearchInput';